import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
    root: {
        ...shorthands.padding("16px")
    },
    container: {
        marginBottom: "20px"
    },
    toggleContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    text: {
        fontFamily: "Segoe UI",
        fontWeight: "600",
        fontSize: "16px",
        lineHeight: "21px"
    },
    toggle: {
        display: "flex"
    },
    timezoneLine: {
        minWidth: "180px",
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "nowrap"
    },
    timezoneClock: {
        position: "absolute",
        right: "10px",
        paddingLeft: "20px"
    },
    timezoneName: {
        display: "block"
    },
    dropdownContainer: {
        paddingTop: "10px"
    },
    dropdown: {
        width: "100%"
    },
    resetContainer: {
        marginTop: "50px"
    },
    resetButton: {
        width: "100%"
    }
});
